import { EchartsWithTheme, Empty, Radio, Select, useTheme } from '@maxtropy/components';
import { memo, useEffect, useMemo, useState } from 'react';
import styles from './index.module.scss';
import { Modal, Space } from 'antd';
import SwitchDate from './SwitchDate';
import { getChartOption } from './chart';
import {
  apiV2ElectricMapDataOverviewGreenRatePost,
  V2ElectricMapDataOverviewGreenRatePostResponse,
} from '@maxtropy/device-customer-apis-v2';

interface GreenRateModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  updateFn?: () => void;
}

// 定义时间选项枚举
export enum TimeActive {
  THIS_MONTH = 'M',
  THIS_YEAR = 'Y',
}

export type BarItem = Exclude<V2ElectricMapDataOverviewGreenRatePostResponse['list'], undefined>[number];

const GreenRateModal: React.FC<GreenRateModalProps> = props => {
  const { open, setOpen, updateFn } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const theme = useTheme();
  const [activeKey, setActiveKey] = useState<TimeActive>(TimeActive.THIS_MONTH);
  const [chartData, setChartData] = useState<BarItem[]>([]);

  useEffect(() => {
    setLoading(true);
    apiV2ElectricMapDataOverviewGreenRatePost({ type: activeKey === TimeActive.THIS_MONTH ? 2 : 3 })
      .then(res => {
        setChartData(res.list ?? []);
      })
      .finally(() => setLoading(false));
  }, [activeKey]);

  const chartOption = useMemo(() => {
    return getChartOption(chartData, activeKey);
  }, [chartData]);

  return (
    <Modal
      title="绿电占比"
      open={open}
      width={640}
      wrapClassName={styles.rateModal}
      mask={false}
      style={{ top: '280px' }}
      onOk={() => {}}
      footer={null}
      onCancel={() => {
        setOpen(false);
      }}
      className={styles.customModal}
      getContainer={() => document.getElementById('full_screen_box') ?? document.body}
    >
      <div style={{ marginTop: 16, height: 350, width: '100%' }}>
        <SwitchDate
          defaultValue={activeKey}
          onChange={setActiveKey}
          options={[
            { label: '本月', value: TimeActive.THIS_MONTH },
            { label: '本年', value: TimeActive.THIS_YEAR },
          ]}
        />
        <EchartsWithTheme
          theme={theme}
          loading={loading}
          empty={{
            isShowEmpty: chartData.length === 0,
            emptyNode: <Empty className={styles.empty_box} />,
          }}
          style={{ height: 300, width: 600, marginTop: 16 }}
          option={chartOption}
        />
      </div>
    </Modal>
  );
};

export default memo(GreenRateModal);
